<template>
    <div class="toast-header">
        <slot></slot>
    </div>  
</template>
